export default __webpack_public_path__ + "static/media/3.7bb6172b.jpg";